import PropTypes from 'prop-types';
import React from 'react';

import {
  CardBodyWrapper, CardHeaderWrapper, CardWrapper, HeaderIcon, HeaderText,
} from './style';

const OrderCard = ({
  title, icon, children, bigSize,
}) => (
  <CardWrapper $bigSize={bigSize}>
    <CardHeaderWrapper>
      <HeaderIcon>
        {icon}
      </HeaderIcon>
      <HeaderText>{title}</HeaderText>
    </CardHeaderWrapper>
    <CardBodyWrapper>
      {children}
    </CardBodyWrapper>
  </CardWrapper>
);

OrderCard.propTypes = {
  title   : PropTypes.string,
  icon    : PropTypes.node.isRequired,
  children: PropTypes.node,
  bigSize : PropTypes.bool,
};

OrderCard.defaultProps = {
  title   : '',
  children: null,
  bigSize : false,
};

export default OrderCard;
